import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IFtpDetail } from './ftpDetail';
import { IFtpDetailFormValues } from './ftpDetailFormValues';
import { IFtpDetailUpsert } from './ftpDetailUpsert';

export default class FtpDetailModelHelper {
    public static createFormValues = (ftpDetail : IFtpDetail | null) : IFtpDetailFormValues => {
        if (!ftpDetail) return {
            id: 0,
            guid: uuidV4(),
            name: '',
            address: '',
            port: 0,
            username: '',
            password: '',
            path: '',
            isActive: true,
        };

        return {
            id: ftpDetail.id,
            guid: ftpDetail.guid,
            name: ftpDetail.name,
            address: ftpDetail.address,
            port: ftpDetail.port,
            username: ftpDetail.username,
            password: ftpDetail.password,
            path: ftpDetail.path,
            isActive: ftpDetail.isActive,
        };
    };

    public static createUpsert = (formValues : IFtpDetailFormValues) : IFtpDetailUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            name: formValues.name,
            address: formValues.address,
            port: formValues.port,
            username: formValues.username,
            password: formValues.password,
            path: formValues.path,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IFtpDetailFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        address: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        username: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        password: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        path: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        port: Yup.number()
            .min(0, 'Port must be between 0 and 65535')
            .max(65535, 'Port must be between 0 and 65535')
            .required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
